import App from './App.svelte';
import './global.css';

if (window.Telegram && window.Telegram.WebApp) {
  Telegram.WebApp.ready();
  // Use the whole WebView height; the SDK keeps --tg-viewport-stable-height updated
  try { Telegram.WebApp.expand(); } catch (e) { /* older clients */ }
}

const app = new App({
  target: document.body
});

export default app;
